import {AInesIcon} from "@/graphql/generated/graphql";
import {
    addCircleOutline,
    callOutline,
    checkmark,
    codeOutline,
    listOutline,
    mailUnreadOutline,
    personAddOutline,
    pinOutline,
    search,
    squareOutline, statsChartOutline, swapVertical,
    timerOutline, walletOutline
} from "ionicons/icons";
import {kapitelErrorHandler} from "@/helper/error";


export type IconDescription = {
    __typename?: 'IconDescription';
    iconId: string;
    iconType: 'ion' | 'icon';
}


export const iconType2Icon = (icon: AInesIcon): IconDescription => {
    switch (true) {
        case icon === AInesIcon.BookingSuggestion:
            return {iconId: KapitelIcon.diensttausch, iconType: 'icon'}
        case icon === AInesIcon.BookingWithdrawal:
            return {iconId: KapitelIcon.diensttausch, iconType: 'icon'}
        case icon === AInesIcon.Onboarding:
            return {iconId: personAddOutline, iconType: 'ion'}
        case icon === AInesIcon.Planning:
            return {iconId: "/icons/strategy.svg", iconType: 'icon'}
        case icon === AInesIcon.PlanningCompleted:
            return {iconId: checkmark, iconType: 'ion'}
        case icon === AInesIcon.Timesheet:
            return {iconId: timerOutline, iconType: 'ion'}
        case icon === AInesIcon.WishDemand:
            return {iconId: search, iconType: 'ion'}
        case icon === AInesIcon.RegisterBookingConfirmationMissing:
            return {iconId: callOutline, iconType: 'ion'}
        case icon === AInesIcon.HumanRequest:
            return {iconId: "/icons/question.svg", iconType: 'icon'}
        case icon === AInesIcon.DirectDemand:
            return {iconId: mailUnreadOutline, iconType: 'ion'}
        case icon === AInesIcon.Jobsites:
            return {iconId: pinOutline, iconType: 'ion'}
        case icon === AInesIcon.ShiftTimes:
            return {iconId: codeOutline, iconType: 'ion'}
        case icon === AInesIcon.Payroll:
            return {iconId: statsChartOutline, iconType: 'ion'}
        case icon === AInesIcon.Employee:
            return {iconId: KapitelIcon.employee, iconType: 'icon'}
        default:
            kapitelErrorHandler('unknown icon type')
            return {iconId: squareOutline, iconType: 'ion'}
    }
}

export const KapitelIcon = {
    sick: '/icons/first-aid-kit.svg',
    vacation: '/icons/island.svg',
    azkAusgleich: '/icons/trend-down.svg',
    booking: '/icons/calendar-dot.svg',
    registerBooking: '/icons/calendar-plus.svg',
    itemList: listOutline,
    shiftPlan: '/icons/calendar-dots.svg',
    timesheet: '/icons/clock-user.svg',
    planning: '/icons/strategy.svg',
    favoriteJobsite: '/icons/heart.svg',
    alternativeJobsite: '/icons/plus.svg',
    blockedJobsite: '/icons/x.svg',
    kpi: '/icons/chart-line.svg',
    jobsite: '/icons/house.svg',
    question: '/icons/question.svg',
    questionFill: '/icons/question-fill.svg',
    info: '/icons/info.svg',
    infoFill: '/icons/info-fill.svg',
    employee: '/icons/user-circle.svg',
    employeePictureMissing: '/icons/user-focus.svg',
    calendarSync: '/icons/arrows-clockwise.svg',
    stoebern: '/icons/compass.svg',
    plus: addCircleOutline,
    edit: '/icons/pencil-simple.svg',
    caret: '/icons/caret-right.svg',
    chat: '/icons/chats.svg',
    diensttausch: '/icons/user-switch.svg',
    warning: '/icons/warning.svg',
    comment: '/icons/chat-centered-text.svg',
}
